import React from "react";

export function PageSkeleton({ title = "Loading…" }) {
  return (
    <div style={{ padding: 16, maxWidth: 980, margin: "0 auto" }}>
      <div style={{ width: 280, height: 26, borderRadius: 12, background: "rgba(0,0,0,0.08)" }} />
      <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
        {[1,2,3,4].map((i) => (
          <div key={i} style={{ height: 74, borderRadius: 14, border: "1px solid rgba(0,0,0,0.08)", background: "rgba(0,0,0,0.03)" }} />
        ))}
      </div>
    </div>
  );
}
